module.exports = __webpack_public_path__ + "assets_1789874507493/img/guide_ios.431fc979.png";